module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iaS1lZGl0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRjb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPgogICAgPHBhdGggZD0iTTMwIDcgTDI1IDIgNSAyMiAzIDI5IDEwIDI3IFogTTIxIDYgTDI2IDExIFogTTUgMjIgTDEwIDI3IFoiIC8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-edit.svg
// module id = IdwL
// module chunks = 53